import React from 'react';
import { useDispatch } from 'react-redux';
import { hideModal } from '../../redux/actions/modal';
import text from '../../text';
import { Modal } from 'react-bootstrap';
import { Button } from '../button';
export var FORCE_JOB_UPDATE_MODAL = 'FORCE_JOB_UPDATE_MODAL';
var ForceJobUpdateModal = function(props) {
    var onSubmit = props.onSubmit, show = props.show;
    var dispatch = useDispatch();
    var onHide = function() {
        return dispatch(hideModal(FORCE_JOB_UPDATE_MODAL));
    };
    var onHandleSubmit = function() {
        onHide();
        onSubmit();
    };
    return /*#__PURE__*/ React.createElement(Modal, {
        centered: true,
        show: show,
        onHide: onHide
    }, /*#__PURE__*/ React.createElement(Modal.Body, null, /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement("h2", {
        className: "text-center"
    }, text('overwriteChanges')), /*#__PURE__*/ React.createElement("p", {
        className: "text-center"
    }, text('overwriteRecentlyUpdatedProject')), /*#__PURE__*/ React.createElement("div", {
        className: "form-footer"
    }, /*#__PURE__*/ React.createElement(Button, {
        autoFocus: true,
        onClick: onHandleSubmit
    }, text('saveAnyway')), /*#__PURE__*/ React.createElement("a", {
        name: "cancel",
        href: "#",
        onClick: function(ev) {
            ev.preventDefault();
            onHide();
        }
    }, text('cancel'))))));
};
export default ForceJobUpdateModal;
